var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnerContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    fill: "#F9E6F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    stroke: "#C90D81",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11704_6228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1318 76.9687C40.9392 68.8157 46.3429 64.7393 52.5861 64.7393C58.8292 64.7393 64.2329 68.8157 75.0403 76.9687L79.1699 80.084L76.0546 75.9544C67.9016 65.147 63.8251 59.7433 63.8251 53.5001C63.8251 47.257 67.9016 41.8533 76.0546 31.0459L79.17 26.9161L75.0403 30.0315C64.2329 38.1845 58.8292 42.261 52.5861 42.261C46.3429 42.261 40.9392 38.1845 30.1318 30.0315L26.0019 26.916L29.1174 31.0459C37.2704 41.8533 41.3469 47.257 41.3469 53.5001C41.3469 59.7433 37.2704 65.147 29.1174 75.9544L26.002 80.0841L30.1318 76.9687Z",
    fill: "#C90D81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11704_6228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.1681,
    height: 53.1681,
    fill: "white",
    transform: "translate(26 26.916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerContent);
export default __webpack_public_path__ + "static/media/LearnerContent.2e228b66f2ec98632340e00faa8388ea.svg";
export { ForwardRef as ReactComponent };